module.exports = __webpack_public_path__ + "img/Dash showing percentage.10906ae6.png";